import { FileResponse, Product, ProductFile, ServiceDataResult, ServiceResult } from '../models';
import cert1 from '../../assets/images/certificates/cert1.png';
import DEFAULT_IMAGE from '../../assets/images/products/default.png';
import { IconType } from '../components/common/Icon';

export const apiCall = async <T extends ServiceResult>(responsePromise: Promise<T>, onSuccess: (reponse: T) => Promise<void>, onError: (response?: T) => Promise<void>) => {
    let response: T = null as any;

    try {
        response = await responsePromise;
    } catch { }

    if (response && !response.hasError) {
        await onSuccess(response);
    } else {
        await onError(response);
    }
};

export const apiCalls = async <T extends ServiceResult>(responsePromises: Promise<T[]>, onSuccess: (reponses: T[]) => Promise<void>, onError: () => Promise<void>) => {
    let responses: T[] = [];

    try {
        responses = await responsePromises;
    } catch { }

    if (responses && responses.every(x => x && !x.hasError)) {
        await onSuccess(responses);
    } else {
        await onError();
    }
};

export const getProductFileImage = (productFile?: ProductFile) => {
    if (productFile && productFile.base64Data && productFile.base64Data.length) {
        return `data:image/jpeg;base64, ${productFile.base64Data}`;
    }

    switch (productFile?.name) {
        case 'default.jpg':
            return DEFAULT_IMAGE;
        default:
            return '';
    }
};

export const getCertImage = (certImageId: string) => {
    switch (certImageId) {
        case `${process.env.DEFAULT_CERT_IMAGE_ID}`:
            return cert1;
        default:
            return '';
    }
};

export const getFileTypeIcon = (filename: string) => {
    const fileExt = filename.split('.').pop();

    switch (fileExt) {
        case 'pdf':
            return IconType.DocumentPDF;
        case 'doc':
            return IconType.DocumentDOC;
        case 'docx':
            return IconType.DocumentDOC;
        case 'xls':
            return IconType.DocumentXLS;
        case 'xlsx':
            return IconType.DocumentXLS;
        case 'ppt':
            return IconType.DocumentPPT;
        case 'pptx':
            return IconType.DocumentPPT;
        default:
            return IconType.Document;
    }
};

export const fileDownload = async <T extends ServiceDataResult<FileResponse>>(responsePromise: Promise<T>, onError: () => Promise<void>, fileName: string, target?: string, openInNewTab?: boolean) => {
    let response: T = null as any;

    try {
        response = await responsePromise;
    } catch { }

    if (response && response.data && response.data.data?.length > 0) {
        const base64Data = `data:application/octet-stream;base64,${response.data.data}`;
        const a = document.createElement('a');
        a.href = base64Data;
        a.download = fileName;
        a.click();
    } else {
        await onError();
    }
};

export const getBaseProductInfoFromUrl = (articleNr: string, serial: string) => {
    const productWithBaseData = {
        id: 1,
        attributes: [
            {
                id: 2,
                language: 0,
                attributeTranslations: [
                {
                    id: 1,
                    name: 'ID-Link',
                    value: `https://i.siemens.com/1P${articleNr}+${serial}`,
                    order: 1
                },
                {
                    id: 2,
                    name: 'Article Number',
                    value: articleNr,
                    order: 2
                },
                {
                    id: 3,
                    name: 'Serial Number',
                    value: serial,
                    order: 3
                }
                ]
            },
            {
                id: 3,
                language: 1,
                attributeTranslations: [
                {
                    id: 4,
                    name: 'ID-Link',
                    value: `https://i.siemens.com/1P${articleNr}+${serial}`,
                    order: 1
                },
                {
                    id: 5,
                    name: 'Artikelnummer',
                    value: articleNr,
                    order: 2
                },
                {
                    id: 6,
                    name: 'Seriennummer',
                    value: serial,
                    order: 3
                }]
            }
        ],
        supportEntryCategories: [],
        certImages: [],
        keyImage: {
            base64Data: '',
            md5Value: 'd0012d5d15c438712a6696c6cb034d3c',
            isImage: true,
            name: 'default.jpg'
        }
    } as Product;

    return productWithBaseData;
};
